import { padronesEnum, solicitantesEnum } from 'views/Tramites/GPM/enums';
// import { getContenTypePorTipoDePadron } from 'api/catalogos';

// models de posibles "propietarios" de padrones
// const modelsPropietarios = ['cuentaunicasir.Ciudadano', 'empresa.Contribuyente'];

// Verificamos si existe paso de modificacion de padron afectado
// const isAfectacionPropietario = () => plantillaDeTramite.pasos_para_tramites.some((paso) => {
//   if (paso.tipo_de_paso === tiposDePasosEnum.MODIFICACION_AFECTADO) {
//     // Verificamos si se modifica alguna de las propiedades que definen "propietarios"
//     return paso.configuracion_de_padron?.configuraciones_de_campos_de_padrones
//       .some((field) => modelsPropietarios.includes(field.model));
//   }
//   return false;
// });

// const solicitanteCambioPropietarioDebeSerNuevoPropietario = true;
// Si se configura que el solicitante de trámites de afectaciones de propietarios
// debe ser siempre el nuevo propietario se valida si es un trámite de afectación
// modificación y se modificará el "propietario" no incluimos filtros de "propietario"
// en la búsqueda del padrón afectado
// (solicitanteCambioPropietarioDebeSerNuevoPropietario && isAfectacionPropietario())

const getParamsPadron = (plantillaDeTramite, tipoDePadronSolicitante, padronSolicitante) => {
  const { tipo_de_padron } = plantillaDeTramite;
  // if (solicitanteCambioPropietarioDebeSerNuevoPropietario && isAfectacionPropietario()) {
  //   return {};
  // }
  if (!plantillaDeTramite.es_propietario || !padronSolicitante) {
    return {};
  }
  if (tipo_de_padron === padronesEnum.EMPRESA) {
    return {
      [tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'ciudadano' : 'contribuyente']: padronSolicitante.id,
    };
  }
  if (tipo_de_padron === padronesEnum.PREDIO) {
    // const contentType = getContenTypePorTipoDePadron(tipoDePadronSolicitante);
    return {
      // content_object: `${contentType}-${padronSolicitante.id}`,
      [tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'ciudadano' : 'contribuyente']: padronSolicitante.id,
    };
  }
  if (tipo_de_padron >= padronesEnum.HOSPEDAJE
    && tipo_de_padron <= padronesEnum.AGENCIA) {
    return {
      [tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'empresa__ciudadano' : 'empresa__contribuyente']: padronSolicitante.id,
    };
  }
  if ([padronesEnum.VEHICULO, padronesEnum.MOTOCICLETA, padronesEnum.REMOLQUE]
    .includes(tipo_de_padron)) {
    return {
      [tipoDePadronSolicitante === solicitantesEnum.CIUDADANO
        ? 'propietario' : 'contribuyente_propietario']: padronSolicitante.id,
    };
  }
  return {};
};

export default getParamsPadron;
